import * as z from "@-/com.npmjs.zod";

export const displayGraphemeSchema = z.object({
  /** Glyph shown in the UI; may differ when previewing another script. */
  display: z.string(),
  /** Canonical grapheme used for navigation, lookups, and study progress. */
  grapheme: z.string(),
});

export type DisplayGrapheme = z.infer<typeof displayGraphemeSchema>;

export function createDisplayGrapheme(grapheme: string, display = grapheme): DisplayGrapheme {
  return { display, grapheme };
}

export function normalizeDisplayGrapheme(value: string | DisplayGrapheme): DisplayGrapheme {
  return typeof value === "string" ? createDisplayGrapheme(value) : value;
}
